import { Link, useLocation } from "@tanstack/react-router";
import { cn } from "@/lib/utils";

const items = [
  { to: "/tapes", label: "Tapes" },
  { to: "/auditions", label: "Auditions" },
  { to: "/calendar", label: "Calendar" },
  { to: "/snapshots", label: "Snapshots" },
] as const;

export function MobileNav() {
  const location = useLocation();

  return (
    <div className="sm:hidden">
      <div className="container max-w-6xl mx-auto px-5 pb-2">
        <nav
          aria-label="Primary"
          className="flex w-full items-center gap-1"
        >
          {items.map(({ to, label }) => {
            const active = location.pathname.startsWith(to);
            return (
              <Link
                key={to}
                to={to}
                search={{} as never}
                className={cn(
                  "flex-1 text-center px-3 py-1.5 rounded-full text-[13px] font-medium tracking-tight transition-all duration-200",
                  active
                    ? "bg-foreground/[0.06] text-foreground"
                    : "text-muted-foreground hover:text-foreground",
                )}
              >
                {label}
              </Link>
            );
          })}
        </nav>
      </div>
    </div>
  );
}
